import { useInputValidations } from '@/composable/input-validations';
import { i18nGlobal as i18n } from '@/i18n';

const {
  requiredRule, urlRule, emailRule,
  emailTest, lowercaseTest,
  phoneRule, numberRule, kanaRule,
} = useInputValidations();

/**
 * @duplicated '@/composable/input-validations' を使ってください
 */
const mixin = {
  methods: {
    requiredRule(value) {
      return requiredRule(value);
    },
    urlRule(value) {
      return urlRule(value);
    },
    phoneRule(value) {
      return phoneRule(value);
    },
    emailRule(value) {
      return emailRule(value);
    },
    emailTest(str) {
      return emailTest(str);
    },
    lowercaseTest(str) {
      return lowercaseTest(str);
    },
    kanaRule(value) {
      return kanaRule(value);
    },
    slugRule(value) {
      if (!value) return true; // ハイフンでの開始終了不可、小文字、英数字
      const pattern = /^[a-z0-9]{1}[a-z0-9-]{2,30}[a-z0-9]{1}$/;
      return pattern.test(value) || i18n.t('validation.slug');
    },
    numberRule(value) {
      return numberRule(value);
    },
  },
};

export default mixin;
